<template>
  <input
    type="number"
    class="h-10 border rounded-full focus:outline-none px-5"
    :class="`border-${color}`"
    v-bind="$attrs"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>

<script>
export default {
  name: 'AppTextInputNumber',

  props: {
    color: String,
    modelValue: Number,
  },
}
</script>
